import React from "react";
// import CategoryWhyChooseUs from "../category-components/CategoryWhyChooseUs";
import CuisineFeatureSection from "../category-components/CuisineFeatureSection";
import CuisineProduct from "../category-components/CuisineProduct";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
import CuisineChoose from "../category-components/CuisineChoose";

const IndianCuisine = () => {
  return (
    <div>
      <SeoHelmet page="indian-cuisine" />
      <BreadcrumbBanner
        title="Indian Cuisine"
        backgroundImage="/Images/banner-about.jpg"
      />
      <CuisineFeatureSection />
      <CuisineProduct />
      <CuisineChoose/>
    </div>
  );
};

export default IndianCuisine;
